import React, { useReducer } from "react";

import { HostedPage } from "../../api/grpc/subscription/subscription";
import { ProductStoreCartView } from "./ProductStoreCartView";
import { ProductStoreCheckoutDialog } from "./ProductStoreCheckoutDialog";
import {
  CartSummary,
  cartReducer,
  createCart,
  getCartSummary,
} from "./productStoreCart";
import { PurchaseOffer } from "./productStorePurchase";

interface Props {
  /** The product "Order now" was clicked on, with its add-ons and shipping. */
  offer: PurchaseOffer;
  /** Creates the Chargebee checkout for the cart. */
  createCheckout: (summary: CartSummary) => Promise<Pick<HostedPage, "url">>;
  onClose: () => void;
  /** Payment went through for this cart. */
  onComplete?: (summary: CartSummary) => void;
}

/**
 * "Complete your order": the cart, then Chargebee's checkout. The cart is
 * kept here, so it survives going back and forth.
 */
export const ProductStoreCartDialog = ({
  offer,
  createCheckout,
  onClose,
  onComplete,
}: Props) => {
  const [cart, dispatch] = useReducer(cartReducer, undefined, createCart);
  const summary = getCartSummary(offer, cart);

  return (
    <ProductStoreCheckoutDialog
      title="Complete your order"
      review={(onContinue) => (
        <ProductStoreCartView
          offer={offer}
          cart={cart}
          summary={summary}
          dispatch={dispatch}
          onContinue={onContinue}
        />
      )}
      createCheckout={() => createCheckout(summary)}
      onClose={onClose}
      onComplete={() => onComplete?.(summary)}
    />
  );
};
